import { Stack, Card, vars } from '@etg/wings';
import type { TripType } from '@eti/schema-types';
import { css, cx } from '@eti/styles';
import type { Dispatch, SetStateAction } from 'react';
import ItineraryBound from '../../pages/order-details/components/overview/itinerary/drawer/ItineraryBound';
import type { Bound, UpgradeTypePerBound } from './models';

const cardStyles = css`
  padding: 0;
`;

const cardWithBorderStyles = css`
  border: solid 1px ${vars.colors.divider};
`;

interface TripItineraryProps {
  bounds: Bound[];
  hasBoundBorder?: boolean;
  selectedBoundId?: string;
  setIsItineraryDrawerSelfTransferModalOpen?: Dispatch<SetStateAction<boolean>>;
  tripType: TripType;
  segmentsCabinUpgradePrices?: UpgradeTypePerBound[] | null;
}

const TripItinerary = ({
  bounds,
  hasBoundBorder,
  selectedBoundId,
  setIsItineraryDrawerSelfTransferModalOpen,
  tripType,
  segmentsCabinUpgradePrices,
}: TripItineraryProps) => {
  return (
    <Stack role="list">
      {bounds?.map((bound, index: number) => (
        <Card
          className={cx(cardStyles, {
            [cardWithBorderStyles]: hasBoundBorder,
          })}
          key={bound.boundId}
          role="listitem"
        >
          <ItineraryBound
            boundId={bound.boundId}
            boundIndex={index}
            isSelected={selectedBoundId ? bound.boundId === selectedBoundId : true}
            journeyType={tripType}
            originalVersion={bound.originalVersion}
            segments={bound.segments}
            segmentsCabinUpgradePrices={segmentsCabinUpgradePrices}
            setIsItineraryDrawerSelfTransferModalOpen={setIsItineraryDrawerSelfTransferModalOpen}
          />
        </Card>
      ))}
    </Stack>
  );
};

export default TripItinerary;
